import React from 'react';
import '../../Settings.scss';

export const NotificationTip: React.FC = () => (
  <div className="settingsTip">
    For the best experience with notifications, please make sure you have turned on the browser
    alerts at all times.
  </div>
);